import { selectConsultationRenalDetectRecommendation } from '@app/store/consultation/consultation.selectors';
import { PetInfo } from '@app/core/models';
import { selectBreeds } from '@app/store/core';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { dailyAllowanceFeatureKey } from '../daily-allowance-feature-key';
import { DailyAllowanceState } from '../daily-allowance.state';
import { getIbwFromBcsAndLifeStage } from '@app/shared/utils/static-helpers/rationing-helper';
import { selectProfile, selectWeight } from '@app/store/patient-profile/patient-profile.selectors';

const selectState = createFeatureSelector<DailyAllowanceState>(dailyAllowanceFeatureKey);
/**
 * Deactivate identification in SRS mode
 */
export const selectSteps = createSelector(selectState, (state) => state.steps);
export const selectStep = createSelector(selectState, (state) => state.step);

/**
 * Deprecated pet info selector for old components compatibilty
 */
export const selectDailyAllowancePetSummary = createSelector(
  selectProfile,
  selectWeight,
  selectConsultationRenalDetectRecommendation,
  selectBreeds,
  (profile, weight, renalDetectRecommendation, breeds) => {
    return (
      !!profile &&
      <PetInfo>{
        ...profile,
        breedObject: breeds?.find((b) => b.breedCode === profile.breed),
        bcs: weight?.bcs,
        weight: weight?.currentWeight,
        targetWeight: weight?.targetWeight,
        IBW: getIbwFromBcsAndLifeStage(weight, profile),
        petActivity: weight?.petActivity,
        pathologies: renalDetectRecommendation?.pathologies || [],
        sensitivities: [],
      }
    );
  },
);
